import { makeAutoObservable } from "mobx";

class CommonStore {
  bottomNavigationIndex = 0;
  showBrowserWarning = true;
  askUserToDownloadCertificate = true;

  showHeaderInDashboard = true;

  job = null;

  setJob = (job) => {
    this.job = job;
  };

  collapse = true;
  tempCollapse = false;
  resume = false;
  progress = 0;
  ApplicationProgress1 = 0;
  jobresume = null;
  botlabel = "Basic job details";
  interviewLabels = [
    {
      item: "Interview",
      isActive: true,
      skipped: false,
    },
    {
      item: "Settings",
      isActive: false,
      skipped: false,
    },
    {
      item: "Preview",
      isActive: false,
      skipped: false,
    },
  ];
  label = [
    {
      item: "Basic Job Details",
      isActive: true,
      skipped: false,
    },
    {
      item: "Prescreening",
      isActive: false,
      skipped: false,
    },
    {
      item: "MCQ Test",
      isActive: false,
      skipped: false,
    },
    {
      item: "Skill Interview",
      isActive: false,
      skipped: false,
    },
    {
      item: "HR Interview",
      isActive: false,
      skipped: false,
    },
    {
      item: "Task",
      isActive: false,
      skipped: false,
    },
    {
      item: "Settings",
      isActive: false,
      skipped: false,
    },
    // {
    //   item: "Other platforms",
    //   isActive: false,
    //   skipped: false,
    // },
    {
      item: "Preview",
      isActive: false,
      skipped: false,
    },
  ];
  ApplicationProgress = [
    {
      item: "Applied",
      isActive: true,
    },
    {
      item: "MCQ test",
      isActive: true,
      hidden: true,
      completed: false,
    },
    {
      item: "Technical interview",
      isActive: true,
      hidden: true,
      completed: false,
    },
    {
      item: "HR interview",
      isActive: true,
      hidden: true,
      completed: false,
    },
    {
      item: "Shortlist",
      isActive: true,
      completed: false,
      rejected: false,
    },
    {
      item: "Hired",
      isActive: true,
      completed: false,
      hired: false,
    },
  ];
  isPlayingInterviewer = false;
  setIsPlayingInterviewer = (value) => {
    this.isPlayingInterviewer = value ?? false;
  };
  isPlayingCandidate = false;
  setIsPlayingCandidate = (value) => {
    this.isPlayingCandidate = value ?? false;
  };
  isSequentialPlayback = false;
  setIsSequentialPlayback = (value) => {
    this.isSequentialPlayback = value ?? false;
  };

  currentQuestionIndex = 0;
  setCurrentQuestionIndex = (value) => {
    this.currentQuestionIndex = value ?? 0;
  };

  isPlaying = "question";
  setIsPlaying = (value) => {
    this.isPlaying = value;
  };
  voiceSpeed = 1;
  setVoiceSpeed = (value) => {
    this.voiceSpeed = value ?? 1;
  };
  voicePitch = 1;
  setVoicePitch = (value) => {
    this.voicePitch = value ?? 1;
  };

  resetInterviewLabels = () => {
    this.interviewLabels = [
      {
        item: "Interview",
        isActive: true,
        skipped: false,
      },
      {
        item: "Settings",
        isActive: false,
        skipped: false,
      },
      {
        item: "Preview",
        isActive: false,
        skipped: false,
      },
    ];
  };

  setApplicationProgress = (value) => {
    this.ApplicationProgress = value;
  };
  setApplicationProgress1 = (value) => {
    this.ApplicationProgress1 = value;
  };
  createNewBack = false;
  setJobResume = (value) => {
    this.jobresume = value;
  };

  setCreateNewBack = (value) => {
    this.createNewBack = value ?? false;
  };
  setLabelSkipped = (index, value) => {
    if (this.label && this.label[index]) {
      this.label[index].skipped = value;
    } else {
      console.warn(`Cannot set skipped property: label[${index}] is undefined`);
    }
  };

  setInterviewLabelSkipped = (index, value) => {
    if (this.interviewLabels && this.interviewLabels[index]) {
      this.interviewLabels[index].skipped = value;
    } else {
      console.warn(`Cannot set skipped property: interviewLabels[${index}] is undefined`);
    }
  };

  setInterviewLabelActive = (index, value) => {
    if (this.interviewLabels && this.interviewLabels[index]) {
      this.interviewLabels[index].isActive = value;
    } else {
      console.warn(`Cannot set isActive property: interviewLabels[${index}] is undefined`);
    }
  };

  setLabelActive = (index, value) => {
    if (this.label && this.label[index]) {
      this.label[index].isActive = value;
    } else {
      console.warn(`Cannot set isActive property: label[${index}] is undefined`);
    }
  };
  setBotLabel = (value) => {
    this.botlabel = value ?? "Basic job details";
  };
  setProgress = (value) => {
    this.progress = value ?? 0;
  };
  setResume = (value) => {
    this.resume = value ?? false;
  };

  setCollapse = (value) => {
    this.collapse = value ?? false;
  };

  settempCollapse = (value) => {
    this.tempCollapse = value ?? false;
  };

  setShowHeaderInDashboard = (value) => {
    this.showHeaderInDashboard = value ?? false;
  };

  setAskUserToDownloadCertificate(ask) {
    this.askUserToDownloadCertificate = ask ?? false;
  }

  setBrowserWarning(show) {
    this.showBrowserWarning = show ?? false;
  }

  setBottomNavigationIndex(index) {
    this.bottomNavigationIndex = index;
  }

  constructor() {
    makeAutoObservable(this);
  }
}

export default CommonStore;
